import React from 'react';

import { MultipleChoiceQuestionWithResults } from '../../types';

import MultipleChoiceQuestionOptionPreview from '../MultipleChoiceQuestionOptionPreview';
import MultipleChoiceQuestionContainer from '../MultipleChoiceQuestionContainer';

interface MultipleChoiceQuestionPreviewProps {
  hideNoAnswerOption?: boolean;
  hideScores?: boolean;
  hideQuestionBackgroundColor?: boolean;
  question?: MultipleChoiceQuestionWithResults;
  loading?: boolean;
}

const MultipleChoiceQuestionPreview = (props: MultipleChoiceQuestionPreviewProps) => {
  const { hideNoAnswerOption = false, hideQuestionBackgroundColor = false, hideScores = false, question, loading = false } = props;

  return (
    <MultipleChoiceQuestionContainer
      question={question}
      loading={loading}
      selectedOptionType={question?.selectedOptionType}
      selectedOption={question?.selectedOption}
      noColors={hideQuestionBackgroundColor}
      hideScores={hideScores}
      score={question?.score}
      renderOption={(index, option) => <MultipleChoiceQuestionOptionPreview key={option?._id || index} option={option} loading={loading} />}
      renderNoAnswerOption={() => {
        if (hideNoAnswerOption) {
          return null;
        }
        <MultipleChoiceQuestionOptionPreview noColors={hideQuestionBackgroundColor || !!question?.selectedOption} />;
      }}
    />
  );
};

export default MultipleChoiceQuestionPreview;
